import { useCallback, useContext, useEffect, useState } from 'react';

import { ColSize, ContentSection } from '../../../../../../../../../../../../../shared/components';
import { FormActivities } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepTwoFormContext } from '../../../../../../../StepTwo/contexts/StepTwoForm';

import './index.css';

export const Activities = () => {
  const { activities, setActivities } = useContext(StepTwoFormContext);

  const [activeTab, setActiveTab] = useState(activities[0].key);
  const [tabs, setTabs] = useState<Array<any>>([]);

  const onChangeActivitiesForm = useCallback(
    (acitivityKey: string, peopleByActivity: Array<any>) => {
      const newActivitiesInfo = activities.map((activity) =>
        acitivityKey === activity.key
          ? { ...activity, people: peopleByActivity }
          : activity
      );

      setActivities(newActivitiesInfo);
    },
    [activities, setActivities]
  );

  const createTabs = useCallback(() => {
    const newTabs = activities.map((activity, index) => ({
      children: (
        <FormActivities
          activity={activity}
          index={index + 1}
          onChangeActivitiesForm={onChangeActivitiesForm}
        />
      ),
      closable: false,
      key: activity.key,
      label: `Actividad ${activity.activity}`,
    }));

    setTabs(newTabs);
  }, [activities, onChangeActivitiesForm, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <ContentSection level='h3' title='Actividades' hasCard={false}>
      <ColSize size={100}>
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={tabs}
        />
      </ColSize>
    </ContentSection>
  );
};
